import { baseBackend } from "../../../../../../api/base/baseUrl";

export async function getRenewVehiclesRequest(token) {
  return baseBackend.get("/api/v2/vehicle/renew", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function approveRenewVehicleRequest(token, vehicleId, requestId) {
  return baseBackend.post(
    `/api/v2/vehicle/renew/${vehicleId}/approve`,
    { requestId },
    { headers: { Authorization: `Bearer ${token}` } },
  );
}
